export default __webpack_public_path__ + "static/media/2396.ab8c7aee.png";